import React from 'react';
import './nxt_ext_banner.scss';
var plugin_url = nxtext_ajax_object.nxtex_url;
import { __ } from '@wordpress/i18n';

const NxtWidgetBanner = () => {
    return (

        <div className='nxt_ext_banner_cover_box'>
            <div className='nxt_ext_banner_left_content'>
                <p className='nxt_ext_banner_top_sm_strip'><img src={plugin_url + 'assets/svg/dashboard_tab/shield_icon.svg'} draggable={false} />{ __('60 days Money-Back Guarantee', 'nexter-extension')}</p>
                <h2 className='nxt_ext_banner_heading'>{ __('Upgrade to Nexter Pro to Unlock 90+ WordPress', 'nexter-extension') } <br/>{ __(' Blocks, 1000+ Ready Made Templates &', 'nexter-extension') }<br/>{ __(' 50+ Extensions.', 'nexter-extension') } </h2>
                <div className='nxt_ext_banner_btn_group'>
                <a className="nxt_ext_banner_btn" target="_blank" rel="noopener noreferrer" href='https://nexterwp.com/pricing/?utm_source=wpbackend&utm_medium=banner&utm_campaign=nextersettings'><img className='nxt_pro_icon' src={plugin_url + 'assets/svg/premium_icon.svg'} draggable={false} />{ __('Upgrade Now', 'nexter-extension')}</a>
                    <a className='nxt_ext_banner_btn_link' target="_blank" rel="noopener noreferrer" href='https://nexterwp.com/?utm_source=wpbackend&utm_medium=banner&utm_campaign=nextersettings'>{ __('Learn More', 'nexter-extension')} </a>
                </div>
                <ul className='nxt_banner_points_listing'>
                  <li className='nxt_banner_points_strip'><img src={plugin_url + 'assets/svg/dashboard_tab/tpae_check_white_icon.svg'} draggable={false} />{ __('100% Performance Optimised', 'nexter-extension')}</li>
                  <li className='nxt_banner_points_strip'><img src={plugin_url + 'assets/svg/dashboard_tab/tpae_check_white_icon.svg'} draggable={false} />{ __('Create Websites in 60 Secs', 'nexter-extension')}</li>
                  <li className='nxt_banner_points_strip'><img src={plugin_url + 'assets/svg/dashboard_tab/tpae_check_white_icon.svg'} draggable={false} />{ __('Trusted by 20K+ Users', 'nexter-extension')}</li>
                </ul>
            </div>
            <div className='nxt_ext_banner_right_content'>
                <img className='nxt_ext_banner_right_img' src={plugin_url + 'assets/images/nexter_ext_banner.png'} draggable={false}></img>
            </div>
        </div>



    )
}

export default NxtWidgetBanner;